import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';

@Component({
  selector: 'app-common-latest-news',
  templateUrl: './latest-news.component.html',
  imports: [CommonModule, UrlParamsPipe],
})
export class CommonLatestNewsComponent implements OnInit {
  @Input() blogData: any;
  @Input() isWhiteBg: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  newsList: any;
  ngOnInit(): void {
    this.newsList = this.blogData;
  }
  ngOnChanges(): void {
    this.newsList = this.blogData;
  }
}
